export default __webpack_public_path__ + "static/media/bg.9553d704.png";